import React from 'react';
import { Icon } from 'semantic-ui-react';
import { logout } from './authClient';

const LogoutButton = () => <Icon style={{ color: '#00D6DC' }} size="large" link onClick={logout} name="log out" />;

export default LogoutButton;
